import BaseModel from "lib/model";

export default BaseModel.extend({
    props: {
        amount: {
            type: "number",
            required: true,
        },
        created_on: {
            type: "utcDate",
        },
        paymentGroupId: {
            type: "string",
        },
        area: "string",
        source: "string",
    },
    url: function () {
        if (this._id) {
            return `/payment-group/${this.paymentGroupId}/shipment/${this._id}`;
        } else {
            return `/payment-group/${this.paymentGroupId}/shipment`;
        }
    },
});
